import React from "react";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { languageNames } from "@/locales";
import { useLanguageRouter } from "@/hooks/useLanguageRouter";

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const { currentLang, changeLanguage } = useLanguageRouter();

  const getCurrentLanguageName = () => {
    const lang = languageNames.find(l => l.code === currentLang);
    return lang ? lang.name : 'English';
  };

  const handleLanguageChange = (newLang: string) => {
    if (i18n.language !== newLang) {
      i18n.changeLanguage(newLang);
    }
    changeLanguage(newLang);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="gap-2 text-sm"
        >
          <Globe className="h-4 w-4" />
          <span className="hidden md:inline">{getCurrentLanguageName()}</span>
          <span className="md:hidden">{currentLang.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 max-h-[400px] overflow-y-auto">
        {languageNames.map(({ code, name }) => (
          <DropdownMenuItem
            key={code}
            onClick={() => handleLanguageChange(code)}
            className="cursor-pointer flex items-center justify-between"
          >
            <span>{name}</span>
            {currentLang === code && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
